import * as React from 'react';

import { DropdownFilter, FloorsDropdown } from '../../../../components/Filters/';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../../../types/redux';
import { changeSavedFilters } from '../../../../actions/filters';
import { useEventCallback } from '@cian/react-utils';
import { selectFloorsFilter } from '../../../../selectors/filters';
import { EFloors } from '../../../../types/buildersProjects';
import { getFloorsLabel } from './utils/getFloorsLabel';
import { sortListValue } from '../../utils/sortListValues';
import { useDropdownFilter } from '../../hooks/useDropdownFilter';

const SORTED_FLOORS = [EFloors.One, EFloors.Two, EFloors.ThreeAndMore];

export const FloorsContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const floors = useSelector(selectFloorsFilter, shallowEqual);

  const { filterRef, isOpen, tooltipOpened, onClick, onClose } = useDropdownFilter('floors');

  const handleFloorsChange = useEventCallback((newSelectedFloors: EFloors[]) => {
    const newFloors = sortListValue(newSelectedFloors, SORTED_FLOORS);

    dispatch(changeSavedFilters({ floors: newFloors }, 'floors'));
  });

  const label = React.useMemo(() => getFloorsLabel(floors) || 'Этажность', [floors]);

  return (
    <div ref={filterRef}>
      <DropdownFilter
        open={isOpen}
        label={label}
        openTooltip={tooltipOpened}
        onClose={onClose}
        onClick={onClick}
        dataName="Floors"
        dropdownContent={
          <FloorsDropdown
            floors={floors}
            tooltipOpened={tooltipOpened}
            onChange={handleFloorsChange}
            onClose={onClose}
            filterRef={filterRef}
          />
        }
      />
    </div>
  );
};
